<template>
  <div>
    <ul class="style-nav style2 main-line">
      <ul class="style-nav style2">
        <div
          v-if="CheckUserPermission([1, 2, 3, 4, 12])"
          class="bars-icon dropdown"
        >
          <button
            class="btn dropdown-toggle selection-user-bar"
            type="button"
            data-toggle="dropdown"
          >
            <p>
              <i class="fas fa-bars" aria-hidden="true"></i
              >{{ "USERS LIST" }}({{ selectedUsers.length }})
              <span class="caret"></span>
            </p>
          </button>
          <ul class="dropdown-menu ul-users">
            <li
              v-for="user in usersList"
              :key="user.id"
              :class="{ activedrop: selectedUsers.includes(user.id) }"
              @click="clickOnUserId(user)"
            >
              <a>
                {{ user.full_name }}
              </a>
            </li>
          </ul>
        </div>
        <li
          class="avg-btn"
          :class="{ activeavg: avgLine }"
          @click="(avgLine = !avgLine), renderChart()"
        >
          AVG
        </li>
      </ul>
      <ul class="style-nav style2" v-if="chartsMainView === 'DYNAMIC'">
        <li v-for="tab in customTab" :key="tab.id" :class="{ active: true }">
          {{ tab.name }}
        </li>
      </ul>
    </ul>
    <div class="chart-box">
      <ul v-if="chartsMainView === 'DYNAMIC'" class="main-tabs">
        <li
          v-for="tab in leftGraphTabs"
          :key="tab.id"
          @click="clickOnMainTab(tab.alias)"
        >
          {{ tab.name }}
        </li>
      </ul>
      <div class="styleCardContent">
        <div
          v-show="selectedGraphTab === 'DYNAMIC'"
          :class="{ fromMain: chartsMainView !== 'DYNAMIC' }"
          class="campaign-chart"
        >
          <canvas width="1" id="dynamic-chart-vol"></canvas>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import moment from "moment";
import apiClientCreator from "../../../../../helpers/api/request";
import Chart from "chart.js";
import ChartDataLabels from "chartjs-plugin-datalabels";
import UsersPermissionCheck from "@/mixins/user/auth/UsersPermissionCheck";
import UsersActiveScope from "@/features/company.feature/sub_features.company/clients_table.sub_feature.company/mixins/UsersActiveScope";
import UsersStatsActiveScope from "@/features/company.feature/sub_features.company/clients_table.sub_feature.company/mixins/UsersStatsActiveScope";

const LineVolChartOpt = {
  type: "line",
  options: {
    layout: {
      padding: {
        top: 2
      }
    },
    plugins: {
      datalabels: {
        align: "end",
        anchor: "end",
        offset: -5,

        font: {
          family: "Montserrat"
        },
        fontSize: 9,
        color: function(context) {
          return "#44A2D2";
        },
        formatter: function(value) {
          return value ? value : "";
        }
      }
    },

    maintainAspectRatio: false,
    gradientColors: [
      "rgba(29,140,248,0.2)",
      "rgba(29,140,248,0.0)",
      "rgba(29,140,248,0)"
    ],
    gradientStops: [1, 0.4, 0],
    responsive: true,
    scales: {
      yAxes: [
        {
          gridLines: {
            drawBorder: false,
            color: "transparent",
            zeroLineColor: "rgba(70,204,253,0.22)" //"rgba(70,204,253,0.22)",
          },
          ticks: {
            //display:false,
            // beginAtZero: true,
            padding: 15,
            fontColor: "transparent", //"#44A2D2",
            fontFamily: "Montserrat",
            fontSize: 1
          }
        }
      ],
      xAxes: [
        {
          id: "bar-x-axis1",
          // barPercentage: 1.0,
          // categoryPercentage: 0.5,
          gridLines: {
            drawBorder: false,
            color: "transparent",
            zeroLineColor: "transparent"
          },
          ticks: {
            padding: 0,
            fontColor: "#44A2D2",
            fontFamily: "Montserrat",
            fontSize: 10
          }
        }
      ]
    },
    legend: {
      display: true,
      position: "top",
      align: "end",
      labels: {
        boxWidth: 20,
        fontSize: 10
      },
      onHover: function(e) {
        e.target.style.cursor = "pointer";
      }
    },
    hover: {
      onHover: function(e) {
        const point = this.getElementAtEvent(e);
        if (point.length) e.target.style.cursor = "pointer";
        else e.target.style.cursor = "default";
      }
    }
  }
};

export default {
  name: "DynamicLineChart.component",
  mixins: [UsersActiveScope, UsersStatsActiveScope, UsersPermissionCheck],
  props: {
    userNames: {
      type: String
    },
    date: {
      type: Object
    },
    mainChart: {
      type: Boolean
    }
  },
  mounted() {
    this.usersList = this.FilterStatsNonActiveUsers(
      this.FilterNonActiveUsers()
    );

    if (this.mainChart) {
      this.usersList = this.userNames;
      this.selectedUsers = [];

      this.usersList.map(user => {
        this.selectedUsers.push(user.id);
      });
      this.$store.commit("clients/setDynamicChartUsers", this.selectedUsers);
      this.$store.commit("clients/setDynamicChartDates", {
        start: moment(this.date.start).format("YYYY-MM-DD"),
        end: moment(this.date.end).format("YYYY-MM-DD")
      });
    }
  },
  data() {
    return {
      LineVolChartOpt: LineVolChartOpt,
      ArDataLineChart: [],
      selectedGraphTab: "DYNAMIC",
      dynamicChartTabs: [
        {
          id: 1,
          name: "DYNAMIC",
          alias: "DYNAMIC"
        }
      ],

      DynamicChartBuild: null,

      showGraph: true,
      timeRange: {},

      customTab: [
        {
          id: 0,
          name: "Custom",
          alias: "CUSTOM"
        }
      ],
      leftGraphTabs: [
        {
          id: 4,
          name: "DEP",
          alias: "DEPOSITS"
        },
        {
          id: 5,
          name: "S-C",
          alias: "TO_CS"
        },
        {
          id: 6,
          name: "S-V",
          alias: "DP_SEC_VOICE"
        },
        {
          id: 9,
          name: "TRNS",
          alias: "TRANS"
        },
        {
          id: 10,
          name: "ASMT",
          alias: "AS"
        },
        {
          id: 11,
          name: "MDFY",
          alias: "AS_MD"
        },
        {
          id: 12,
          name: "REG",
          alias: "TO_REG"
        },
        {
          id: 13,
          name: "IMP",
          alias: "LIVE_DATA"
        }
      ],
      queryObject: {},
      selectedUsers: [],
      usersList: [],
      avgLine: false
    };
  },
  computed: {
    ...mapState("clients", ["generalQueryObject", "chartsMainView"])
  },
  watch: {
    date: function() {
      if (this.mainChart) {
        this.usersList = this.userNames;
        this.selectedUsers = [];
        this.usersList.map(user => {
          this.selectedUsers.push(user.id);
        });
        this.$store.commit("clients/setDynamicChartUsers", this.selectedUsers);
        this.$store.commit("clients/setDynamicChartDates", {
          start: moment(this.date.start).format("YYYY-MM-DD"),
          end: moment(this.date.end).format("YYYY-MM-DD")
        });
      }
    },
    selectedUsers: function() {
      //this.fetchDataToDynamicChart();
    },
    generalQueryObject: function() {
      if (
        (this.chartsMainView === "DYNAMIC" || this.mainChart) &&
        this.CheckUserPermission([1, 2, 3, 4, 12])
      ) {
        this.queryObject = this.generalQueryObject;
        apiClientCreator.source.cancel();
        if (
          this.queryObject.hasOwnProperty("deposit_users") &&
          this.queryObject.deposit_users.length > 0 &&
          this.queryObject.hasOwnProperty("deposit_at_from") &&
          this.queryObject.hasOwnProperty("deposit_at_to")
        ) {
          this.selectedUsers = this.queryObject.deposit_users;
          this.fetchDataToDynamicChart();
          return;
        } else {
          this.$store.commit("clients/setChartsMainView", "DEP");
        }
      }
    }
  },
  methods: {
    renderChart() {
      let ChartCanvasId = "dynamic-chart-vol";
      this.createDynamicVolChart(
        this.ArDataLineChart,
        ChartCanvasId,
        this.LineVolChartOpt
      );
    },
    clickOnUserId(user) {
      if (this.selectedUsers.includes(user.id)) {
        this.selectedUsers = this.selectedUsers.filter(id => id !== user.id);
      } else {
        this.selectedUsers.push(user.id);
      }
      //this.$store.commit("clients/setDynamicChartUsers", this.selectedUsers);
    },
    clickOnMainTab(alias) {
      this.$store.commit("clients/setMainGraphTabData", alias);
    },
    async fetchDataToDynamicChart() {
      this.ArDataLineChart = [];
      let queryParams = Object.assign(this.queryObject);
      let ChartCanvasId = "dynamic-chart-vol";
      let tempObj = await apiClientCreator(`client/stats/dynamic/volatility`)
        .get("", {
          params: queryParams,
          cancelToken: apiClientCreator.source.token
        })
        .then();
      this.ArDataLineChart = tempObj.data;
      if (this.ArDataLineChart.length > 0) {
        this.createDynamicVolChart(
          this.ArDataLineChart,
          ChartCanvasId,
          this.LineVolChartOpt
        );
      }
    },

    createDynamicVolChart(stats, chartId, chartOpt) {
      let opt = chartOpt.options;
      const counts = [];
      let labels = [];
      let dataSets = [];
      let set = [];

      stats.map(data => {
        set = [];
        labels = [];
        data.dates.map(item => {
          set.push(item.count);
          labels.push(item.date);
        });
        let color = this.random_rgba();
        dataSets.push({
          type: "line",
          label: data.user.full_name,
          fill: false,
          borderColor: color, //"rgba(186,231,85,0.9)",
          borderWith: 1,
          backgroundColor: color,
          pointBackgroundColor: color,
          pointBorderColor: color,
          pointHoverBackgroundColor: color,
          pointHoverBorderColor: color,
          data: set,
          hidden: this.avgLine
        });
      });
      let totalAvg = [];
      if (this.avgLine) {
        for (const i in labels) {
          let tempAvg =
            stats.reduce((a, b) => a + b.dates[i].count, 0) / stats.length;
          totalAvg.push(tempAvg.toFixed(1));
        }
        let color = this.random_rgba();
        dataSets.push({
          type: "line",
          label: "AVG",
          fill: false,
          borderColor: color, //"rgba(186,231,85,0.9)",
          borderWith: 1,
          backgroundColor: "#e755ba",
          pointBackgroundColor: color,
          pointBorderColor: color,
          pointHoverBackgroundColor: color,
          pointHoverBorderColor: color,
          data: totalAvg
        });
      }

      if (counts.length > 0) {
        opt.annotation = this.returnAverageLine(
          counts.reduce((a, b) => a + b) / counts.length,
          true,
          "rgba(0,89,149,0.83)",
          255
        );
      }
      const data = {
        labels: labels,
        datasets: dataSets
      };

      if (this.DynamicChartBuild) {
        this.DynamicChartBuild.destroy();
      }
      const ctx = document.getElementById(chartId);
      this.DynamicChartBuild = new Chart(ctx, {
        type: chartOpt.type,
        data: data,
        options: opt,
        plugins: [ChartDataLabels]
      });
    },

    returnAverageLine: (avg, enabled, lineColor, pose, YAdjust = -10) => ({
      annotations: [
        {
          type: "line",
          mode: "horizontal",
          scaleID: "y-axis-0",
          value: avg,
          borderColor: lineColor,
          borderWidth: 1,
          borderDash: [2, 2],
          label: {
            // Background color of label, default below
            backgroundColor: "rgba(0,0,0,0)",

            // Font family of text, inherits from global
            fontFamily: "Montserrat",

            // Font size of text, inherits from global
            fontSize: 10,

            // Font style of text, default below
            // fontStyle: "bold",

            // Font color of text, default below
            fontColor: "#000",

            // Padding of label to add left/right, default below
            xPadding: 4,

            // Padding of label to add top/bottom, default below
            yPadding: 4,

            // Radius of label rectangle, default below
            cornerRadius: 5,

            // Anchor position of label on line, can be one of: top, bottom, left, right, center. Default below.
            position: "center",

            // Adjustment along x-axis (left-right) of label relative to above number (can be negative)
            // For horizontal lines positioned left or right, negative values move
            // the label toward the edge, and positive values toward the center.
            xAdjust: pose,

            // Adjustment along y-axis (top-bottom) of label relative to above number (can be negative)
            // For vertical lines positioned top or bottom, negative values move
            // the label toward the edge, and positive values toward the center.

            yAdjust: YAdjust,

            // Whether the label is enabled and should be displayed
            enabled: enabled,

            // Text to display in label - default is null. Provide an array to display values on a new line
            content: avg.toFixed(0),

            // Rotation of label, in degrees, default is 0
            rotation: 90
          }
        },

        {}
      ]
    }),

    random_rgba() {
      let o = Math.round,
        r = Math.random,
        s = 255;
      return "rgb(" + o(r() * s) + "," + o(r() * s) + "," + o(r() * s) + ")";
    }
  }
};
</script>

<style lang="scss" scoped>
$tabFontSize: 11px;
html * {
  text-transform: capitalize;
}
.styleCard {
  box-shadow: 0px 9px 20px rgba(0, 0, 0, 0.05);
  border-radius: 5px;
  overflow: hidden;
  min-height: 100%;
  position: relative;
  font-family: Montserrat;
}
.styleCardContent {
  background: white;
  min-height: 12rem;
  height: 100%;
  flex: 2;
}
.style-nav {
  margin: 0;
  padding: 0;
  list-style: none;
  display: flex;
  position: relative;
  max-width: 100%;
  border-radius: 0;
  /*
                                background: white;
                              */
}
.style-nav.style2 li {
  transition: transform 0.1s ease;
}
.style-nav.style2 li:not(:last-child) {
  margin-right: 2px;
}

.style-nav li {
  max-width: 100%;
  min-width: 90px;
  height: 25px;
  margin: 0;
  cursor: pointer;
  background: white;
  border-radius: 0;
  font-size: $tabFontSize;
  text-align: center;
  vertical-align: middle;
  line-height: 25px;
  border-bottom: 2px solid transparent;
  flex-grow: 1;
  transition: background 0.2s ease, color 0.2s ease;
}

.style-nav.style2 li:not(.empty):hover {
  transform: translateY(1px);
}

.style-nav.style2 li.active {
  border-bottom: none !important;
  background-color: #efefef;
  color: black;
}

.style-nav.style1 li:not(.empty):hover {
  background: #44a2d2;
  color: white;
}

.style-nav.style1 li.active {
  border-bottom: 2px solid #44a2d2 !important;
  background: #44a2d2;
  color: white;
}
.padding {
  padding: 5px;
}

.campaign-chart {
  width: 100%;
  height: 170px;
}
.campaign-chart.fromMain {
  width: 100%;
  height: 150px;
}
.nav-tabs a {
  height: 25px;
  padding: 5px;
}
.nav-tabs li.active {
  border-top-color: transparent !important;
  border-bottom: 2px solid;
  border-bottom-color: #1e88e5;
  font-family: "Montserrat", Montserrat, serif;
  font-size: $tabFontSize;
  font-weight: bold;
  color: #1e88e5;
}
.main-line {
  display: flex;
  justify-content: space-between;
  min-width: 100%;
  align-self: end;
  flex-grow: 1;
}
.chart-box {
  display: flex;
  align-items: stretch;
  background-color: white;
}
.main-tabs {
  max-width: 5%;
  max-height: 100%;
  margin: 0;
  padding: 0;
  list-style: none;
  display: flex;
  flex-direction: column;
  position: relative;
  background: white;
  flex: 1;
}

.main-tabs.style2 li {
  max-height: 10%;
  border-radius: 5px 5px 0px 0px;
  transition: transform 0.1s ease;
}

.main-tabs.style2 li:not(:last-child) {
  /*margin-right: 2px;*/
}

.main-tabs li {
  max-width: 100%;
  min-width: 45px;
  height: 20px;
  margin: 0;
  cursor: pointer;
  background: white;
  border-radius: 0;
  font-size: $tabFontSize;
  text-align: left;
  vertical-align: middle;
  line-height: 25px;
  border-bottom: 2px solid transparent;
  flex-grow: 1;
  transition: background 0.2s ease, color 0.2s ease;
  margin-left: 3px;
}

.main-tabs li:not(.empty):hover {
  transform: translateY(1px);
}

.main-tabs li.active {
  border-bottom: 1px solid #44a2d2 !important;
  color: #44a2d2;
}

.main-tabs.style1 li:not(.empty):hover {
  background: #44a2d2;
  color: white;
}

.main-tabs.style1 li.active {
  border-bottom: 2px solid #44a2d2 !important;
  background: #44a2d2;
  color: white;
}

.selection-user-bar {
  width: 100%;
  display: flex;
  justify-content: space-between;
  height: 25px;
  border-radius: 0px;
  font-size: 11px;
  color: #000;
}
.dropdown-menu.ul-users {
  font-size: 14px;
  overflow-y: scroll;
  max-height: 165px;
  border-radius: 0px;
  width: 100%;
  cursor: pointer;
  border: none;
  min-width: 160px;
}
.dropdown-menu {
  border-radius: 0;
}
.avg-btn {
  background: #efefef;
}
.avg-btn.activeavg {
  background: #14afde;
}
</style>
